<template>
  <!-- 表示テンプレート設定タブ -->
  <div id="DisplayTemplateSetting">
    <div id="container-modal">
      <div class="template-select-area">
        <select v-model.number="selectedTemplateId" class="template-select-box" size="6" @change="selectDisplayTemplate()">
          <option v-for="displayTemplate in displayTemplateList" :key="displayTemplate.id" :value="displayTemplate.id">
            <a v-if="displayTemplate.defaultFlag">【既定】</a>{{ displayTemplate.templateName }}
          </option>
        </select>
        <div class="buttonArea">
          <fieldset :disabled="!selectingFlag">
            <b-button class="is-primary" @click="deleteDisplayTemplate()">削除</b-button>
            <b-button v-if="!selectedTemplateInfo.defaultFlag" class="is-primary" @click="setDefaultDisplayTemplate(true)">既定に設定</b-button>
            <b-button v-if="selectedTemplateInfo.defaultFlag" class="is-primary" @click="setDefaultDisplayTemplate(false)">既定を解除</b-button>
            <b-button class="is-primary arrow-button" @click="upDisplayTemplate()">↑</b-button>
            <b-button class="is-primary arrow-button" @click="downDisplayTemplate()">↓</b-button>
          </fieldset>
        </div>
      </div>
      <div class="template-edit-area">
        <fieldset :disabled="!selectingFlag">
          <div class="template-edit-content">
            <div class="templatename-block">
              <div class="left-area">
                <div class="templatename-label">テンプレート名</div>
                <input class="templatename-input" v-model="inputSelectedTemplateInfo.templateName" maxlength="30"/>
              </div>
              <div class="right-area">
                <b-button class="is-primary" style="margin: 0;" @click="updateDisplayTemplate()">保存</b-button>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { shiftListDetail } from "@/components/mock/guest/patientdashboard/pDashboardUtil";

export default {
  name: "DisplayTemplateSetting",
  data() {
    return {
      /** 表示テンプレートリスト */
      displayTemplateList: {},
      /** メイン画面で表示中のテンプレート */
      displayTemplate: null,
      /** 選択中の表示テンプレート有無（ボタン・入力欄活性化に使用） */
      selectingFlag: false,
      /** 選択中の表示テンプレートID */
      selectedTemplateId: null,
      /** 選択中の表示テンプレート情報 */
      selectedTemplateInfo: {},
      /** 選択中の表示テンプレート情報（入力欄用） */
      inputSelectedTemplateInfo: {},
      /** 表示テンプレート削除リスト */
      displayTemplateDeleteList: []
    }
  },
  methods: {
    // 環境設定画面にて表示テンプレート初期表示情報を取得
    setDisplayTemplateInfo(displayTemplateList, displayTemplate) {
      // 取得結果を表示テンプレートリストにセット
      this.displayTemplateList = displayTemplateList;
      // メイン画面で表示中のテンプレート情報を取得
      this.displayTemplate = displayTemplate;
    },
    // 表示テンプレートを選択
    selectDisplayTemplate() {
      if (this.selectedTemplateId) {
        // IDをキーに選択中の表示テンプレート情報を保持
        this.selectedTemplateInfo = this.displayTemplateList.find(item => item.id == this.selectedTemplateId);
        // 入力欄に表示するテンプレート情報を複製
        this.inputSelectedTemplateInfo = this.getCopy(this.selectedTemplateInfo);
        // 各種ボタン・表示テンプレート名入力欄を活性化
        this.selectingFlag = true;
      }
    },
    // テンプレート未選択状態に戻す
    clearSelected() {
      // 選択中表示テンプレート情報をクリア
      this.selectedTemplateInfo = {};
      // 選択行をクリア
      this.selectedTemplateId = null;
      // 表示テンプレート名入力欄をクリア
      this.inputSelectedTemplateInfo = {};
      // 各種ボタン・表示テンプレート名入力欄を非活性化
      this.selectingFlag = false;
    },
    // 削除ボタン処理
    deleteDisplayTemplate() {
      if (this.selectedTemplateId == this.displayTemplate.id) {
        this.showErrorMessage("メイン画面で選択中のテンプレートは\n削除できません。");
        return;
      }
      const _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "選択しているテンプレートを削除します。<br/>よろしいでしょうか？",
        confirmText:"OK",
        cancelText: "キャンセル",
        onConfirm: () => {
          // 選択中の表示テンプレートを表示テンプレート削除リストに追加
          _this.displayTemplateDeleteList.push(_this.displayTemplateList.find(item => item.id == _this.selectedTemplateId));
          // 表示テンプレート表示リストから削除
          _this.displayTemplateList = _this.displayTemplateList.filter(item => item.id != _this.selectedTemplateId);
          // 表示順が削除対象より大きいテンプレートの表示順を-1する
          for (let displayTemplate of _this.displayTemplateList) {
            if (_this.selectedTemplateInfo.displayOrder < displayTemplate.displayOrder) {
              displayTemplate.displayOrder--;
            }
          }
          _this.clearSelected();
        }
      });
    },
    // 既定に設定・既定を解除ボタン押下時の処理
    setDefaultDisplayTemplate(defaultFlag) {
      for (let displayTemplate of this.displayTemplateList) {
        if (this.selectedTemplateId == displayTemplate.id) {
          // 表示テンプレートの既定フラグを設定
          displayTemplate.defaultFlag = defaultFlag;
        } else {
          // 選択中でない表示テンプレートの既定フラグを削除
          displayTemplate.defaultFlag = false;
        }
      }
    },
    // ↑（上）ボタン押下時の処理
    upDisplayTemplate() {
      if (this.selectedTemplateInfo.displayOrder != 1) {
        this.shiftDisplayTemplate(true);
      }
    },
    // ↓（下）ボタン押下時の処理
    downDisplayTemplate() {
      if (this.selectedTemplateInfo.displayOrder != this.displayTemplateList.at(-1).displayOrder) {
        this.shiftDisplayTemplate(false);
      }
    },
    // テンプレート入れ替え処理
    shiftDisplayTemplate(isUp) {
      // インポートした共通処理を呼び出す
      let result = shiftListDetail(this.displayTemplateList, this.selectedTemplateInfo.displayOrder, isUp, this.selectedTemplateInfo);
      // 入れ替え結果をセット
      this.displayTemplateList = result.targetList;
      this.selectedTemplateInfo = result.selectedRow;
    },
    // 保存ボタン押下時の処理
    updateDisplayTemplate() {
      // 表示テンプレート名入力欄が空欄の場合
      if (!this.inputSelectedTemplateInfo.templateName) {
        this.showMessage("表示テンプレート名を入力してください。");
        return;
      }
      // 入力した表示テンプレート名が重複している場合
      if (this.inputSelectedTemplateInfo.templateName == "標準設定") {
        this.showMessage("この表示テンプレート名は既に登録されています。");
        return;
      }
      let displayTemplate;
      for (displayTemplate of this.displayTemplateList) {
        if (displayTemplate.templateName == this.inputSelectedTemplateInfo.templateName && 
            displayTemplate.id != this.inputSelectedTemplateInfo.id) {
          this.showMessage("この表示テンプレート名は既に登録されています。");
          return;
        }
      }
      // 入力あり＆重複なしの場合、表示テンプレート名を更新
      for (displayTemplate of this.displayTemplateList) {
        if (this.inputSelectedTemplateInfo.id == displayTemplate.id) {
          displayTemplate.templateName = this.inputSelectedTemplateInfo.templateName;
        }
      }
      this.clearSelected();
    }
  }
};
</script>

<style lang="scss" scoped>
.template-select-area {
  display: grid;
  grid-template-columns: 1.7fr 0.3fr;
  margin-right: 11px;
}
.template-edit-area {
  padding: 0 10px 10px 10px;
  margin-top: 16px;
  border: 1px solid #767676;
}
.template-edit-content tr th {
  width: 150px;
  font-size: 16px;
  color: #061e57;
}
.template-edit-content tr th, td {
  height: 36px;
  padding-top: 10px;
}
.buttonArea {
  margin-left: 16px;
}
.is-primary {
  width: 120px;
  height: 25px;
  margin-bottom: 7px;
  display: flex;
}
.arrow-button {
  width: 50px;
  height: 25px;
}
select.template-select-box option {
  height: 24px;
}
select.template-select-box option:checked {
  background: linear-gradient(#061e57, #061e57);
  color: #ffffff;
}
.templatename-block {
  display: grid;
  grid-template-columns: 1fr 136px;
  padding-top: 10px;
  height: 36px;
}
.left-area {
  display: flex;
}
.right-area {
  padding-left: 16px;
  text-align: right;
}
.templatename-label {
  width: 150px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  color: #061e57;
}
.templatename-input {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/DisplayTemplateSetting.vue